import React from 'react';
import { useGlobalContext } from '../../../store/global';
import { useTranslation } from 'react-i18next';

export default function Thanks() {
  const { closeModal } = useGlobalContext();
  const { t }  = useTranslation();

  return (
    <div className="popup-inner thanks" style={{ maxWidth: '650px' }}>
      <div className="popup-title">
        <h2>{t("Thank_you_for_your_reply")}</h2>
        <div className="close icon-x" onClick={closeModal}></div>
      </div>

      <div className="popup-content thanks-content">
        {/* <p>Your reply has been added.</p> */}
        <p>{t("Your_reply_has_been_added")}</p>
        {/* <p>Thank you.</p> */}
        <div className="popup-action">
          <button className="primary big" onClick={closeModal}>
            {t("Back_to_IDEAS")}
          </button>
        </div>
      </div>
    </div>
  );
}
